export const contriesWithLangs = [
  {
    country: {
      name: 'Afghanistan',
      code: 'AF',
    },
    lang: {
      value: 'prs',
      name: 'Dari',
    },
    phone: {
      cca2: 'AF',
      idd: '+93',
    },
  },
  {
    country: {
      name: 'Åland Islands',
      code: 'AX',
    },
    lang: {
      value: 'swe',
      name: 'Swedish',
    },
    phone: {
      cca2: 'AX',
      idd: '+3',
    },
  },
  {
    country: {
      name: 'Albania',
      code: 'AL',
    },
    lang: {
      value: 'sqi',
      name: 'Albanian',
    },
    phone: {
      cca2: 'AL',
      idd: '+355',
    },
  },
  {
    country: {
      name: 'Algeria',
      code: 'DZ',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'DZ',
      idd: '+213',
    },
  },
  {
    country: {
      name: 'American Samoa',
      code: 'AS',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'AS',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Andorra',
      code: 'AD',
    },
    lang: {
      value: 'cat',
      name: 'Catalan',
    },
    phone: {
      cca2: 'AD',
      idd: '+376',
    },
  },
  {
    country: {
      name: 'Angola',
      code: 'AO',
    },
    lang: {
      value: 'por',
      name: 'Portuguese',
    },
    phone: {
      cca2: 'AO',
      idd: '+244',
    },
  },
  {
    country: {
      name: 'Anguilla',
      code: 'AI',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'AI',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Antarctica',
      code: 'AQ',
    },
    lang: {
      value: '',
      name: '',
    },
    phone: {
      cca2: 'AQ',
      idd: '',
    },
  },
  {
    country: {
      name: 'Antigua and Barbuda',
      code: 'AG',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'AG',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Argentina',
      code: 'AR',
    },
    lang: {
      value: 'grn',
      name: 'Guaraní',
    },
    phone: {
      cca2: 'AR',
      idd: '+54',
    },
  },
  {
    country: {
      name: 'Armenia',
      code: 'AM',
    },
    lang: {
      value: 'hye',
      name: 'Armenian',
    },
    phone: {
      cca2: 'AM',
      idd: '+374',
    },
  },
  {
    country: {
      name: 'Aruba',
      code: 'AW',
    },
    lang: {
      value: 'nl',
      name: 'Dutch',
    },
    phone: {
      cca2: 'AW',
      idd: '+297',
    },
  },
  {
    country: {
      name: 'Australia',
      code: 'AU',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'AU',
      idd: '+61',
    },
  },
  {
    country: {
      name: 'Austria',
      code: 'AT',
    },
    lang: {
      value: 'deu',
      name: 'German',
    },
    phone: {
      cca2: 'AT',
      idd: '+43',
    },
  },
  {
    country: {
      name: 'Azerbaijan',
      code: 'AZ',
    },
    lang: {
      value: 'aze',
      name: 'Azerbaijani',
    },
    phone: {
      cca2: 'AZ',
      idd: '+994',
    },
  },
  {
    country: {
      name: 'Bahamas',
      code: 'BS',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'BS',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Bahrain',
      code: 'BH',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'BH',
      idd: '+973',
    },
  },
  {
    country: {
      name: 'Bangladesh',
      code: 'BD',
    },
    lang: {
      value: 'ben',
      name: 'Bengali',
    },
    phone: {
      cca2: 'BD',
      idd: '+880',
    },
  },
  {
    country: {
      name: 'Barbados',
      code: 'BB',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'BB',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Belarus',
      code: 'BY',
    },
    lang: {
      value: 'bel',
      name: 'Belarusian',
    },
    phone: {
      cca2: 'BY',
      idd: '+375',
    },
  },
  {
    country: {
      name: 'Belgium',
      code: 'BE',
    },
    lang: {
      value: 'nl',
      name: 'Dutch',
    },
    phone: {
      cca2: 'BE',
      idd: '+32',
    },
  },
  {
    country: {
      name: 'Belize',
      code: 'BZ',
    },
    lang: {
      value: 'bjz',
      name: 'Belizean Creole',
    },
    phone: {
      cca2: 'BZ',
      idd: '+501',
    },
  },
  {
    country: {
      name: 'Benin',
      code: 'BJ',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'BJ',
      idd: '+229',
    },
  },
  {
    country: {
      name: 'Bermuda',
      code: 'BM',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'BM',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Bhutan',
      code: 'BT',
    },
    lang: {
      value: 'dzo',
      name: 'Dzongkha',
    },
    phone: {
      cca2: 'BT',
      idd: '+975',
    },
  },
  {
    country: {
      name: 'Bolivia',
      code: 'BO',
    },
    lang: {
      value: 'aym',
      name: 'Aymara',
    },
    phone: {
      cca2: 'BO',
      idd: '+591',
    },
  },
  {
    country: {
      name: 'Bosnia and Herzegovina',
      code: 'BA',
    },
    lang: {
      value: 'bos',
      name: 'Bosnian',
    },
    phone: {
      cca2: 'BA',
      idd: '+387',
    },
  },
  {
    country: {
      name: 'Botswana',
      code: 'BW',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'BW',
      idd: '+267',
    },
  },
  {
    country: {
      name: 'Bouvet Island',
      code: 'BV',
    },
    lang: {
      value: 'nor',
      name: 'Norwegian',
    },
    phone: {
      cca2: 'BV',
      idd: '+47',
    },
  },
  {
    country: {
      name: 'Brazil',
      code: 'BR',
    },
    lang: {
      value: 'por',
      name: 'Portuguese',
    },
    phone: {
      cca2: 'BR',
      idd: '+55',
    },
  },
  {
    country: {
      name: 'British Indian Ocean Territory',
      code: 'IO',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'IO',
      idd: '+246',
    },
  },
  {
    country: {
      name: 'British Virgin Islands',
      code: 'VG',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'VG',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Brunei',
      code: 'BN',
    },
    lang: {
      value: 'msa',
      name: 'Malay',
    },
    phone: {
      cca2: 'BN',
      idd: '+673',
    },
  },
  {
    country: {
      name: 'Bulgaria',
      code: 'BG',
    },
    lang: {
      value: 'bul',
      name: 'Bulgarian',
    },
    phone: {
      cca2: 'BG',
      idd: '+359',
    },
  },
  {
    country: {
      name: 'Burkina Faso',
      code: 'BF',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'BF',
      idd: '+226',
    },
  },
  {
    country: {
      name: 'Burundi',
      code: 'BI',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'BI',
      idd: '+257',
    },
  },
  {
    country: {
      name: 'Cambodia',
      code: 'KH',
    },
    lang: {
      value: 'khm',
      name: 'Khmer',
    },
    phone: {
      cca2: 'KH',
      idd: '+855',
    },
  },
  {
    country: {
      name: 'Cameroon',
      code: 'CM',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'CM',
      idd: '+237',
    },
  },
  {
    country: {
      name: 'Canada',
      code: 'CA',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'CA',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Cape Verde',
      code: 'CV',
    },
    lang: {
      value: 'por',
      name: 'Portuguese',
    },
    phone: {
      cca2: 'CV',
      idd: '+238',
    },
  },
  {
    country: {
      name: 'Caribbean Netherlands',
      code: 'BQ',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'BQ',
      idd: '+599',
    },
  },
  {
    country: {
      name: 'Cayman Islands',
      code: 'KY',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'KY',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Central African Republic',
      code: 'CF',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'CF',
      idd: '+236',
    },
  },
  {
    country: {
      name: 'Chad',
      code: 'TD',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'TD',
      idd: '+235',
    },
  },
  {
    country: {
      name: 'Chile',
      code: 'CL',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'CL',
      idd: '+56',
    },
  },
  {
    country: {
      name: 'China',
      code: 'CN',
    },
    lang: {
      value: 'zho',
      name: 'Chinese',
    },
    phone: {
      cca2: 'CN',
      idd: '+86',
    },
  },
  {
    country: {
      name: 'Christmas Island',
      code: 'CX',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'CX',
      idd: '+61',
    },
  },
  {
    country: {
      name: 'Cocos (Keeling) Islands',
      code: 'CC',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'CC',
      idd: '+61',
    },
  },
  {
    country: {
      name: 'Colombia',
      code: 'CO',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'CO',
      idd: '+57',
    },
  },
  {
    country: {
      name: 'Comoros',
      code: 'KM',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'KM',
      idd: '+269',
    },
  },
  {
    country: {
      name: 'Cook Islands',
      code: 'CK',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'CK',
      idd: '+682',
    },
  },
  {
    country: {
      name: 'Costa Rica',
      code: 'CR',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'CR',
      idd: '+506',
    },
  },
  {
    country: {
      name: 'Croatia',
      code: 'HR',
    },
    lang: {
      value: 'hrv',
      name: 'Croatian',
    },
    phone: {
      cca2: 'HR',
      idd: '+385',
    },
  },
  {
    country: {
      name: 'Cuba',
      code: 'CU',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'CU',
      idd: '+53',
    },
  },
  {
    country: {
      name: 'Curaçao',
      code: 'CW',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'CW',
      idd: '+599',
    },
  },
  {
    country: {
      name: 'Cyprus',
      code: 'CY',
    },
    lang: {
      value: 'ell',
      name: 'Greek',
    },
    phone: {
      cca2: 'CY',
      idd: '+357',
    },
  },
  {
    country: {
      name: 'Czechia',
      code: 'CZ',
    },
    lang: {
      value: 'ces',
      name: 'Czech',
    },
    phone: {
      cca2: 'CZ',
      idd: '+420',
    },
  },
  {
    country: {
      name: 'Denmark',
      code: 'DK',
    },
    lang: {
      value: 'dan',
      name: 'Danish',
    },
    phone: {
      cca2: 'DK',
      idd: '+45',
    },
  },
  {
    country: {
      name: 'Djibouti',
      code: 'DJ',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'DJ',
      idd: '+253',
    },
  },
  {
    country: {
      name: 'Dominica',
      code: 'DM',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'DM',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Dominican Republic',
      code: 'DO',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'DO',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'DR Congo',
      code: 'CD',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'CD',
      idd: '+243',
    },
  },
  {
    country: {
      name: 'Ecuador',
      code: 'EC',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'EC',
      idd: '+593',
    },
  },
  {
    country: {
      name: 'Egypt',
      code: 'EG',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'EG',
      idd: '+20',
    },
  },
  {
    country: {
      name: 'El Salvador',
      code: 'SV',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'SV',
      idd: '+503',
    },
  },
  {
    country: {
      name: 'Equatorial Guinea',
      code: 'GQ',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'GQ',
      idd: '+240',
    },
  },
  {
    country: {
      name: 'Eritrea',
      code: 'ER',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'ER',
      idd: '+291',
    },
  },
  {
    country: {
      name: 'Estonia',
      code: 'EE',
    },
    lang: {
      value: 'est',
      name: 'Estonian',
    },
    phone: {
      cca2: 'EE',
      idd: '+372',
    },
  },
  {
    country: {
      name: 'Eswatini',
      code: 'SZ',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'SZ',
      idd: '+268',
    },
  },
  {
    country: {
      name: 'Ethiopia',
      code: 'ET',
    },
    lang: {
      value: 'amh',
      name: 'Amharic',
    },
    phone: {
      cca2: 'ET',
      idd: '+251',
    },
  },
  {
    country: {
      name: 'Falkland Islands',
      code: 'FK',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'FK',
      idd: '+500',
    },
  },
  {
    country: {
      name: 'Faroe Islands',
      code: 'FO',
    },
    lang: {
      value: 'dan',
      name: 'Danish',
    },
    phone: {
      cca2: 'FO',
      idd: '+298',
    },
  },
  {
    country: {
      name: 'Fiji',
      code: 'FJ',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'FJ',
      idd: '+679',
    },
  },
  {
    country: {
      name: 'Finland',
      code: 'FI',
    },
    lang: {
      value: 'fin',
      name: 'Finnish',
    },
    phone: {
      cca2: 'FI',
      idd: '+358',
    },
  },
  {
    country: {
      name: 'France',
      code: 'FR',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'FR',
      idd: '+33',
    },
  },
  {
    country: {
      name: 'French Guiana',
      code: 'GF',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'GF',
      idd: '+594',
    },
  },
  {
    country: {
      name: 'French Polynesia',
      code: 'PF',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'PF',
      idd: '+689',
    },
  },
  {
    country: {
      name: 'French Southern and Antarctic Lands',
      code: 'TF',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'TF',
      idd: '+262',
    },
  },
  {
    country: {
      name: 'Gabon',
      code: 'GA',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'GA',
      idd: '+241',
    },
  },
  {
    country: {
      name: 'Gambia',
      code: 'GM',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'GM',
      idd: '+220',
    },
  },
  {
    country: {
      name: 'Georgia',
      code: 'GE',
    },
    lang: {
      value: 'kat',
      name: 'Georgian',
    },
    phone: {
      cca2: 'GE',
      idd: '+995',
    },
  },
  {
    country: {
      name: 'Germany',
      code: 'DE',
    },
    lang: {
      value: 'deu',
      name: 'German',
    },
    phone: {
      cca2: 'DE',
      idd: '+49',
    },
  },
  {
    country: {
      name: 'Ghana',
      code: 'GH',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'GH',
      idd: '+233',
    },
  },
  {
    country: {
      name: 'Gibraltar',
      code: 'GI',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'GI',
      idd: '+350',
    },
  },
  {
    country: {
      name: 'Greece',
      code: 'GR',
    },
    lang: {
      value: 'ell',
      name: 'Greek',
    },
    phone: {
      cca2: 'GR',
      idd: '+30',
    },
  },
  {
    country: {
      name: 'Greenland',
      code: 'GL',
    },
    lang: {
      value: 'kal',
      name: 'Greenlandic',
    },
    phone: {
      cca2: 'GL',
      idd: '+299',
    },
  },
  {
    country: {
      name: 'Grenada',
      code: 'GD',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'GD',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Guadeloupe',
      code: 'GP',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'GP',
      idd: '+590',
    },
  },
  {
    country: {
      name: 'Guam',
      code: 'GU',
    },
    lang: {
      value: 'cha',
      name: 'Chamorro',
    },
    phone: {
      cca2: 'GU',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Guatemala',
      code: 'GT',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'GT',
      idd: '+502',
    },
  },
  {
    country: {
      name: 'Guernsey',
      code: 'GG',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'GG',
      idd: '+44',
    },
  },
  {
    country: {
      name: 'Guinea',
      code: 'GN',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'GN',
      idd: '+224',
    },
  },
  {
    country: {
      name: 'Guinea-Bissau',
      code: 'GW',
    },
    lang: {
      value: 'por',
      name: 'Portuguese',
    },
    phone: {
      cca2: 'GW',
      idd: '+245',
    },
  },
  {
    country: {
      name: 'Guyana',
      code: 'GY',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'GY',
      idd: '+592',
    },
  },
  {
    country: {
      name: 'Haiti',
      code: 'HT',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'HT',
      idd: '+509',
    },
  },
  {
    country: {
      name: 'Heard Island and McDonald Islands',
      code: 'HM',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'HM',
      idd: '',
    },
  },
  {
    country: {
      name: 'Honduras',
      code: 'HN',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'HN',
      idd: '+504',
    },
  },
  {
    country: {
      name: 'Hong Kong',
      code: 'HK',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'HK',
      idd: '+852',
    },
  },
  {
    country: {
      name: 'Hungary',
      code: 'HU',
    },
    lang: {
      value: 'hun',
      name: 'Hungarian',
    },
    phone: {
      cca2: 'HU',
      idd: '+36',
    },
  },
  {
    country: {
      name: 'Iceland',
      code: 'IS',
    },
    lang: {
      value: 'isl',
      name: 'Icelandic',
    },
    phone: {
      cca2: 'IS',
      idd: '+354',
    },
  },
  {
    country: {
      name: 'India',
      code: 'IN',
    },
    lang: {
      value: 'hin',
      name: 'Hindi',
    },
    phone: {
      cca2: 'IN',
      idd: '+91',
    },
  },
  {
    country: {
      name: 'Indonesia',
      code: 'ID',
    },
    lang: {
      value: 'ind',
      name: 'Indonesian',
    },
    phone: {
      cca2: 'ID',
      idd: '+62',
    },
  },
  {
    country: {
      name: 'Iran',
      code: 'IR',
    },
    lang: {
      value: 'fas',
      name: 'Persian (Farsi)',
    },
    phone: {
      cca2: 'IR',
      idd: '+98',
    },
  },
  {
    country: {
      name: 'Iraq',
      code: 'IQ',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'IQ',
      idd: '+964',
    },
  },
  {
    country: {
      name: 'Ireland',
      code: 'IE',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'IE',
      idd: '+353',
    },
  },
  {
    country: {
      name: 'Isle of Man',
      code: 'IM',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'IM',
      idd: '+44',
    },
  },
  {
    country: {
      name: 'Israel',
      code: 'IL',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'IL',
      idd: '+972',
    },
  },
  {
    country: {
      name: 'Italy',
      code: 'IT',
    },
    lang: {
      value: 'ita',
      name: 'Italian',
    },
    phone: {
      cca2: 'IT',
      idd: '+39',
    },
  },
  {
    country: {
      name: 'Ivory Coast',
      code: 'CI',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'CI',
      idd: '+225',
    },
  },
  {
    country: {
      name: 'Jamaica',
      code: 'JM',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'JM',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Japan',
      code: 'JP',
    },
    lang: {
      value: 'jpn',
      name: 'Japanese',
    },
    phone: {
      cca2: 'JP',
      idd: '+81',
    },
  },
  {
    country: {
      name: 'Jersey',
      code: 'JE',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'JE',
      idd: '+44',
    },
  },
  {
    country: {
      name: 'Jordan',
      code: 'JO',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'JO',
      idd: '+962',
    },
  },
  {
    country: {
      name: 'Kazakhstan',
      code: 'KZ',
    },
    lang: {
      value: 'kaz',
      name: 'Kazakh',
    },
    phone: {
      cca2: 'KZ',
      idd: '+7',
    },
  },
  {
    country: {
      name: 'Kenya',
      code: 'KE',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'KE',
      idd: '+254',
    },
  },
  {
    country: {
      name: 'Kiribati',
      code: 'KI',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'KI',
      idd: '+686',
    },
  },
  {
    country: {
      name: 'Kosovo',
      code: 'XK',
    },
    lang: {
      value: 'sqi',
      name: 'Albanian',
    },
    phone: {
      cca2: 'XK',
      idd: '+383',
    },
  },
  {
    country: {
      name: 'Kuwait',
      code: 'KW',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'KW',
      idd: '+965',
    },
  },
  {
    country: {
      name: 'Kyrgyzstan',
      code: 'KG',
    },
    lang: {
      value: 'kir',
      name: 'Kyrgyz',
    },
    phone: {
      cca2: 'KG',
      idd: '+996',
    },
  },
  {
    country: {
      name: 'Laos',
      code: 'LA',
    },
    lang: {
      value: 'lao',
      name: 'Lao',
    },
    phone: {
      cca2: 'LA',
      idd: '+856',
    },
  },
  {
    country: {
      name: 'Latvia',
      code: 'LV',
    },
    lang: {
      value: 'lav',
      name: 'Latvian',
    },
    phone: {
      cca2: 'LV',
      idd: '+371',
    },
  },
  {
    country: {
      name: 'Lebanon',
      code: 'LB',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'LB',
      idd: '+961',
    },
  },
  {
    country: {
      name: 'Lesotho',
      code: 'LS',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'LS',
      idd: '+266',
    },
  },
  {
    country: {
      name: 'Liberia',
      code: 'LR',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'LR',
      idd: '+231',
    },
  },
  {
    country: {
      name: 'Libya',
      code: 'LY',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'LY',
      idd: '+218',
    },
  },
  {
    country: {
      name: 'Liechtenstein',
      code: 'LI',
    },
    lang: {
      value: 'deu',
      name: 'German',
    },
    phone: {
      cca2: 'LI',
      idd: '+423',
    },
  },
  {
    country: {
      name: 'Lithuania',
      code: 'LT',
    },
    lang: {
      value: 'lit',
      name: 'Lithuanian',
    },
    phone: {
      cca2: 'LT',
      idd: '+370',
    },
  },
  {
    country: {
      name: 'Luxembourg',
      code: 'LU',
    },
    lang: {
      value: 'deu',
      name: 'German',
    },
    phone: {
      cca2: 'LU',
      idd: '+352',
    },
  },
  {
    country: {
      name: 'Macau',
      code: 'MO',
    },
    lang: {
      value: 'por',
      name: 'Portuguese',
    },
    phone: {
      cca2: 'MO',
      idd: '+853',
    },
  },
  {
    country: {
      name: 'Madagascar',
      code: 'MG',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'MG',
      idd: '+261',
    },
  },
  {
    country: {
      name: 'Malawi',
      code: 'MW',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'MW',
      idd: '+265',
    },
  },
  {
    country: {
      name: 'Malaysia',
      code: 'MY',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'MY',
      idd: '+60',
    },
  },
  {
    country: {
      name: 'Maldives',
      code: 'MV',
    },
    lang: {
      value: 'div',
      name: 'Maldivian',
    },
    phone: {
      cca2: 'MV',
      idd: '+960',
    },
  },
  {
    country: {
      name: 'Mali',
      code: 'ML',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'ML',
      idd: '+223',
    },
  },
  {
    country: {
      name: 'Malta',
      code: 'MT',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'MT',
      idd: '+356',
    },
  },
  {
    country: {
      name: 'Marshall Islands',
      code: 'MH',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'MH',
      idd: '+692',
    },
  },
  {
    country: {
      name: 'Martinique',
      code: 'MQ',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'MQ',
      idd: '+596',
    },
  },
  {
    country: {
      name: 'Mauritania',
      code: 'MR',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'MR',
      idd: '+222',
    },
  },
  {
    country: {
      name: 'Mauritius',
      code: 'MU',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'MU',
      idd: '+230',
    },
  },
  {
    country: {
      name: 'Mayotte',
      code: 'YT',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'YT',
      idd: '+262',
    },
  },
  {
    country: {
      name: 'Mexico',
      code: 'MX',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'MX',
      idd: '+52',
    },
  },
  {
    country: {
      name: 'Micronesia',
      code: 'FM',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'FM',
      idd: '+691',
    },
  },
  {
    country: {
      name: 'Moldova',
      code: 'MD',
    },
    lang: {
      value: 'ron',
      name: 'Romanian',
    },
    phone: {
      cca2: 'MD',
      idd: '+373',
    },
  },
  {
    country: {
      name: 'Monaco',
      code: 'MC',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'MC',
      idd: '+377',
    },
  },
  {
    country: {
      name: 'Mongolia',
      code: 'MN',
    },
    lang: {
      value: 'mon',
      name: 'Mongolian',
    },
    phone: {
      cca2: 'MN',
      idd: '+976',
    },
  },
  {
    country: {
      name: 'Montenegro',
      code: 'ME',
    },
    lang: {
      value: 'cnr',
      name: 'Montenegrin',
    },
    phone: {
      cca2: 'ME',
      idd: '+382',
    },
  },
  {
    country: {
      name: 'Montserrat',
      code: 'MS',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'MS',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Morocco',
      code: 'MA',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'MA',
      idd: '+212',
    },
  },
  {
    country: {
      name: 'Mozambique',
      code: 'MZ',
    },
    lang: {
      value: 'por',
      name: 'Portuguese',
    },
    phone: {
      cca2: 'MZ',
      idd: '+258',
    },
  },
  {
    country: {
      name: 'Myanmar',
      code: 'MM',
    },
    lang: {
      value: 'mya',
      name: 'Burmese',
    },
    phone: {
      cca2: 'MM',
      idd: '+95',
    },
  },
  {
    country: {
      name: 'Namibia',
      code: 'NA',
    },
    lang: {
      value: 'afr',
      name: 'Afrikaans',
    },
    phone: {
      cca2: 'NA',
      idd: '+264',
    },
  },
  {
    country: {
      name: 'Nauru',
      code: 'NR',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'NR',
      idd: '+674',
    },
  },
  {
    country: {
      name: 'Nepal',
      code: 'NP',
    },
    lang: {
      value: 'nep',
      name: 'Nepali',
    },
    phone: {
      cca2: 'NP',
      idd: '+977',
    },
  },
  {
    country: {
      name: 'Netherlands',
      code: 'NL',
    },
    lang: {
      value: 'nl',
      name: 'Dutch',
    },
    phone: {
      cca2: 'NL',
      idd: '+31',
    },
  },
  {
    country: {
      name: 'New Caledonia',
      code: 'NC',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'NC',
      idd: '+687',
    },
  },
  {
    country: {
      name: 'New Zealand',
      code: 'NZ',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'NZ',
      idd: '+64',
    },
  },
  {
    country: {
      name: 'Nicaragua',
      code: 'NI',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'NI',
      idd: '+505',
    },
  },
  {
    country: {
      name: 'Niger',
      code: 'NE',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'NE',
      idd: '+227',
    },
  },
  {
    country: {
      name: 'Nigeria',
      code: 'NG',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'NG',
      idd: '+234',
    },
  },
  {
    country: {
      name: 'Niue',
      code: 'NU',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'NU',
      idd: '+683',
    },
  },
  {
    country: {
      name: 'Norfolk Island',
      code: 'NF',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'NF',
      idd: '+672',
    },
  },
  {
    country: {
      name: 'North Korea',
      code: 'KP',
    },
    lang: {
      value: 'kor',
      name: 'Korean',
    },
    phone: {
      cca2: 'KP',
      idd: '+850',
    },
  },
  {
    country: {
      name: 'North Macedonia',
      code: 'MK',
    },
    lang: {
      value: 'mkd',
      name: 'Macedonian',
    },
    phone: {
      cca2: 'MK',
      idd: '+389',
    },
  },
  {
    country: {
      name: 'Northern Mariana Islands',
      code: 'MP',
    },
    lang: {
      value: 'cal',
      name: 'Carolinian',
    },
    phone: {
      cca2: 'MP',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Norway',
      code: 'NO',
    },
    lang: {
      value: 'nno',
      name: 'Norwegian Nynorsk',
    },
    phone: {
      cca2: 'NO',
      idd: '+47',
    },
  },
  {
    country: {
      name: 'Oman',
      code: 'OM',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'OM',
      idd: '+968',
    },
  },
  {
    country: {
      name: 'Pakistan',
      code: 'PK',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'PK',
      idd: '+92',
    },
  },
  {
    country: {
      name: 'Palau',
      code: 'PW',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'PW',
      idd: '+680',
    },
  },
  {
    country: {
      name: 'Palestine',
      code: 'PS',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'PS',
      idd: '+970',
    },
  },
  {
    country: {
      name: 'Panama',
      code: 'PA',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'PA',
      idd: '+507',
    },
  },
  {
    country: {
      name: 'Papua New Guinea',
      code: 'PG',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'PG',
      idd: '+675',
    },
  },
  {
    country: {
      name: 'Paraguay',
      code: 'PY',
    },
    lang: {
      value: 'grn',
      name: 'Guaraní',
    },
    phone: {
      cca2: 'PY',
      idd: '+595',
    },
  },
  {
    country: {
      name: 'Peru',
      code: 'PE',
    },
    lang: {
      value: 'aym',
      name: 'Aymara',
    },
    phone: {
      cca2: 'PE',
      idd: '+51',
    },
  },
  {
    country: {
      name: 'Philippines',
      code: 'PH',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'PH',
      idd: '+63',
    },
  },
  {
    country: {
      name: 'Pitcairn Islands',
      code: 'PN',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'PN',
      idd: '+64',
    },
  },
  {
    country: {
      name: 'Poland',
      code: 'PL',
    },
    lang: {
      value: 'pol',
      name: 'Polish',
    },
    phone: {
      cca2: 'PL',
      idd: '+48',
    },
  },
  {
    country: {
      name: 'Portugal',
      code: 'PT',
    },
    lang: {
      value: 'por',
      name: 'Portuguese',
    },
    phone: {
      cca2: 'PT',
      idd: '+351',
    },
  },
  {
    country: {
      name: 'Puerto Rico',
      code: 'PR',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'PR',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Qatar',
      code: 'QA',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'QA',
      idd: '+974',
    },
  },
  {
    country: {
      name: 'Republic of the Congo',
      code: 'CG',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'CG',
      idd: '+242',
    },
  },
  {
    country: {
      name: 'Réunion',
      code: 'RE',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'RE',
      idd: '+262',
    },
  },
  {
    country: {
      name: 'Romania',
      code: 'RO',
    },
    lang: {
      value: 'ron',
      name: 'Romanian',
    },
    phone: {
      cca2: 'RO',
      idd: '+40',
    },
  },
  {
    country: {
      name: 'Russia',
      code: 'RU',
    },
    lang: {
      value: 'rus',
      name: 'Russian',
    },
    phone: {
      cca2: 'RU',
      idd: '+7',
    },
  },
  {
    country: {
      name: 'Rwanda',
      code: 'RW',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'RW',
      idd: '+250',
    },
  },
  {
    country: {
      name: 'Saint Barthélemy',
      code: 'BL',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'BL',
      idd: '+590',
    },
  },
  {
    country: {
      name: 'Saint Helena, Ascension and Tristan da Cunha',
      code: 'SH',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'SH',
      idd: '+2',
    },
  },
  {
    country: {
      name: 'Saint Kitts and Nevis',
      code: 'KN',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'KN',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Saint Lucia',
      code: 'LC',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'LC',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Saint Martin',
      code: 'MF',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'MF',
      idd: '+590',
    },
  },
  {
    country: {
      name: 'Saint Pierre and Miquelon',
      code: 'PM',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'PM',
      idd: '+508',
    },
  },
  {
    country: {
      name: 'Saint Vincent and the Grenadines',
      code: 'VC',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'VC',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Samoa',
      code: 'WS',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'WS',
      idd: '+685',
    },
  },
  {
    country: {
      name: 'San Marino',
      code: 'SM',
    },
    lang: {
      value: 'ita',
      name: 'Italian',
    },
    phone: {
      cca2: 'SM',
      idd: '+378',
    },
  },
  {
    country: {
      name: 'São Tomé and Príncipe',
      code: 'ST',
    },
    lang: {
      value: 'por',
      name: 'Portuguese',
    },
    phone: {
      cca2: 'ST',
      idd: '+239',
    },
  },
  {
    country: {
      name: 'Saudi Arabia',
      code: 'SA',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'SA',
      idd: '+966',
    },
  },
  {
    country: {
      name: 'Senegal',
      code: 'SN',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'SN',
      idd: '+221',
    },
  },
  {
    country: {
      name: 'Serbia',
      code: 'RS',
    },
    lang: {
      value: 'srp',
      name: 'Serbian',
    },
    phone: {
      cca2: 'RS',
      idd: '+381',
    },
  },
  {
    country: {
      name: 'Seychelles',
      code: 'SC',
    },
    lang: {
      value: 'crs',
      name: 'Seychellois Creole',
    },
    phone: {
      cca2: 'SC',
      idd: '+248',
    },
  },
  {
    country: {
      name: 'Sierra Leone',
      code: 'SL',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'SL',
      idd: '+232',
    },
  },
  {
    country: {
      name: 'Singapore',
      code: 'SG',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'SG',
      idd: '+65',
    },
  },
  {
    country: {
      name: 'Sint Maarten',
      code: 'SX',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'SX',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Slovakia',
      code: 'SK',
    },
    lang: {
      value: 'slk',
      name: 'Slovak',
    },
    phone: {
      cca2: 'SK',
      idd: '+421',
    },
  },
  {
    country: {
      name: 'Slovenia',
      code: 'SI',
    },
    lang: {
      value: 'slv',
      name: 'Slovene',
    },
    phone: {
      cca2: 'SI',
      idd: '+386',
    },
  },
  {
    country: {
      name: 'Solomon Islands',
      code: 'SB',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'SB',
      idd: '+677',
    },
  },
  {
    country: {
      name: 'Somalia',
      code: 'SO',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'SO',
      idd: '+252',
    },
  },
  {
    country: {
      name: 'South Africa',
      code: 'ZA',
    },
    lang: {
      value: 'afr',
      name: 'Afrikaans',
    },
    phone: {
      cca2: 'ZA',
      idd: '+27',
    },
  },
  {
    country: {
      name: 'South Georgia',
      code: 'GS',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'GS',
      idd: '+500',
    },
  },
  {
    country: {
      name: 'South Korea',
      code: 'KR',
    },
    lang: {
      value: 'kor',
      name: 'Korean',
    },
    phone: {
      cca2: 'KR',
      idd: '+82',
    },
  },
  {
    country: {
      name: 'South Sudan',
      code: 'SS',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'SS',
      idd: '+211',
    },
  },
  {
    country: {
      name: 'Spain',
      code: 'ES',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'ES',
      idd: '+34',
    },
  },
  {
    country: {
      name: 'Sri Lanka',
      code: 'LK',
    },
    lang: {
      value: 'sin',
      name: 'Sinhala',
    },
    phone: {
      cca2: 'LK',
      idd: '+94',
    },
  },
  {
    country: {
      name: 'Sudan',
      code: 'SD',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'SD',
      idd: '+249',
    },
  },
  {
    country: {
      name: 'Suriname',
      code: 'SR',
    },
    lang: {
      value: 'nl',
      name: 'Dutch',
    },
    phone: {
      cca2: 'SR',
      idd: '+597',
    },
  },
  {
    country: {
      name: 'Svalbard and Jan Mayen',
      code: 'SJ',
    },
    lang: {
      value: 'nor',
      name: 'Norwegian',
    },
    phone: {
      cca2: 'SJ',
      idd: '+4',
    },
  },
  {
    country: {
      name: 'Sweden',
      code: 'SE',
    },
    lang: {
      value: 'swe',
      name: 'Swedish',
    },
    phone: {
      cca2: 'SE',
      idd: '+46',
    },
  },
  {
    country: {
      name: 'Switzerland',
      code: 'CH',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'CH',
      idd: '+41',
    },
  },
  {
    country: {
      name: 'Syria',
      code: 'SY',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'SY',
      idd: '+963',
    },
  },
  {
    country: {
      name: 'Taiwan',
      code: 'TW',
    },
    lang: {
      value: 'zho',
      name: 'Chinese',
    },
    phone: {
      cca2: 'TW',
      idd: '+886',
    },
  },
  {
    country: {
      name: 'Tajikistan',
      code: 'TJ',
    },
    lang: {
      value: 'rus',
      name: 'Russian',
    },
    phone: {
      cca2: 'TJ',
      idd: '+992',
    },
  },
  {
    country: {
      name: 'Tanzania',
      code: 'TZ',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'TZ',
      idd: '+255',
    },
  },
  {
    country: {
      name: 'Thailand',
      code: 'TH',
    },
    lang: {
      value: 'tha',
      name: 'Thai',
    },
    phone: {
      cca2: 'TH',
      idd: '+66',
    },
  },
  {
    country: {
      name: 'Timor-Leste',
      code: 'TL',
    },
    lang: {
      value: 'por',
      name: 'Portuguese',
    },
    phone: {
      cca2: 'TL',
      idd: '+670',
    },
  },
  {
    country: {
      name: 'Togo',
      code: 'TG',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'TG',
      idd: '+228',
    },
  },
  {
    country: {
      name: 'Tokelau',
      code: 'TK',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'TK',
      idd: '+690',
    },
  },
  {
    country: {
      name: 'Tonga',
      code: 'TO',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'TO',
      idd: '+676',
    },
  },
  {
    country: {
      name: 'Trinidad and Tobago',
      code: 'TT',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'TT',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Tunisia',
      code: 'TN',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'TN',
      idd: '+216',
    },
  },
  {
    country: {
      name: 'Turkey',
      code: 'TR',
    },
    lang: {
      value: 'tur',
      name: 'Turkish',
    },
    phone: {
      cca2: 'TR',
      idd: '+90',
    },
  },
  {
    country: {
      name: 'Turkmenistan',
      code: 'TM',
    },
    lang: {
      value: 'rus',
      name: 'Russian',
    },
    phone: {
      cca2: 'TM',
      idd: '+993',
    },
  },
  {
    country: {
      name: 'Turks and Caicos Islands',
      code: 'TC',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'TC',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Tuvalu',
      code: 'TV',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'TV',
      idd: '+688',
    },
  },
  {
    country: {
      name: 'Uganda',
      code: 'UG',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'UG',
      idd: '+256',
    },
  },
  {
    country: {
      name: 'Ukraine',
      code: 'UA',
    },
    lang: {
      value: 'ukr',
      name: 'Ukrainian',
    },
    phone: {
      cca2: 'UA',
      idd: '+380',
    },
  },
  {
    country: {
      name: 'United Arab Emirates',
      code: 'AE',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'AE',
      idd: '+971',
    },
  },
  {
    country: {
      name: 'United Kingdom',
      code: 'GB',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'GB',
      idd: '+44',
    },
  },
  {
    country: {
      name: 'United States',
      code: 'US',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'US',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'United States Minor Outlying Islands',
      code: 'UM',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'UM',
      idd: '+268',
    },
  },
  {
    country: {
      name: 'United States Virgin Islands',
      code: 'VI',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'VI',
      idd: '+1',
    },
  },
  {
    country: {
      name: 'Uruguay',
      code: 'UY',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'UY',
      idd: '+598',
    },
  },
  {
    country: {
      name: 'Uzbekistan',
      code: 'UZ',
    },
    lang: {
      value: 'rus',
      name: 'Russian',
    },
    phone: {
      cca2: 'UZ',
      idd: '+998',
    },
  },
  {
    country: {
      name: 'Vanuatu',
      code: 'VU',
    },
    lang: {
      value: 'bis',
      name: 'Bislama',
    },
    phone: {
      cca2: 'VU',
      idd: '+678',
    },
  },
  {
    country: {
      name: 'Vatican City',
      code: 'VA',
    },
    lang: {
      value: 'ita',
      name: 'Italian',
    },
    phone: {
      cca2: 'VA',
      idd: '+3',
    },
  },
  {
    country: {
      name: 'Venezuela',
      code: 'VE',
    },
    lang: {
      value: 'spa',
      name: 'Spanish',
    },
    phone: {
      cca2: 'VE',
      idd: '+58',
    },
  },
  {
    country: {
      name: 'Vietnam',
      code: 'VN',
    },
    lang: {
      value: 'vie',
      name: 'Vietnamese',
    },
    phone: {
      cca2: 'VN',
      idd: '+84',
    },
  },
  {
    country: {
      name: 'Wallis and Futuna',
      code: 'WF',
    },
    lang: {
      value: 'fra',
      name: 'French',
    },
    phone: {
      cca2: 'WF',
      idd: '+681',
    },
  },
  {
    country: {
      name: 'Western Sahara',
      code: 'EH',
    },
    lang: {
      value: 'ber',
      name: 'Berber',
    },
    phone: {
      cca2: 'EH',
      idd: '+2',
    },
  },
  {
    country: {
      name: 'Yemen',
      code: 'YE',
    },
    lang: {
      value: 'ara',
      name: 'Arabic',
    },
    phone: {
      cca2: 'YE',
      idd: '+967',
    },
  },
  {
    country: {
      name: 'Zambia',
      code: 'ZM',
    },
    lang: {
      value: 'eng',
      name: 'English',
    },
    phone: {
      cca2: 'ZM',
      idd: '+260',
    },
  },
  {
    country: {
      name: 'Zimbabwe',
      code: 'ZW',
    },
    lang: {
      value: 'bwg',
      name: 'Chibarwe',
    },
    phone: {
      cca2: 'ZW',
      idd: '+263',
    },
  },
];
export const suggestedLanguages = [
  {
    value: 'de',
    name: 'German',
  },
  {
    value: 'eng',
    name: 'English',
  },
  {
    value: 'fra',
    name: 'French',
  },
  {
    value: 'jpn',
    name: 'Japanese',
  },
  {
    value: 'ita',
    name: 'Italian',
  },
  {
    value: 'spa',
    name: 'Spanish',
  },
  {
    value: 'nl',
    name: 'Dutch',
  },
];
